import React from 'react';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { useStyles, DeleteSessionButton } from './DeleteButton.styles';
import { WorkMode } from '../SessionTree/SessionTree.types';
import TooltipOneComponent from '../TooltipOne/TooltipOne.component';

interface DeleteButtonProps {
  workMode: WorkMode;
  isDisabled?: boolean;
  handleDeleteMode?: () => void;
}

const DeleteButton: React.FC<DeleteButtonProps> = (props) => {
  const classes = useStyles();

  return (
    <>
      <TooltipOneComponent
        title={props.workMode === WorkMode.EDIT && props.isDisabled ? 'Nie można usunąć tego elementu' : ''}
        placement="top"
      >
        <span>
          <DeleteSessionButton
            className={classes.deleteButton}
            variant="contained"
            disabled={props.workMode === WorkMode.EDIT && props.isDisabled}
            startIcon={<DeleteOutlineIcon className={classes.deleteButtonIcon} />}
            onClick={props.handleDeleteMode}
          >
            Usuń
          </DeleteSessionButton>
        </span>
      </TooltipOneComponent>
    </>
  );
};

export default DeleteButton;
